module.exports = __webpack_public_path__ + "img/undraw_code_thinking.10a41e5f.svg";